import { render, staticRenderFns } from "./generic-search-result.vue?vue&type=template&id=5f3cb628&"
import script from "./generic-search-result.vue?vue&type=script&lang=js&"
export * from "./generic-search-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports